import _asyncToGenerator from '@babel/runtime-corejs3/helpers/esm/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime-corejs3/regenerator';
import _Promise from '@babel/runtime-corejs3/core-js-stable/promise';
import _setTimeout from '@babel/runtime-corejs3/core-js-stable/set-timeout';

/**
 * Creates a promise that resolves after the given number of milliseconds.
 *
 * @param time - The time of the timeout in milliseconds
 * @public
 *
 * @example
 * ```javascript
 * import { timeout } from '@thisisbud/timer-utils'
 *
 * timeout(5000).then(function () {
 *   // Do something
 * })
 *
 * // OR
 *
 * async function foobar() {
 *   await timeout(5000)
 *   // Do something
 * }
 * ```
 */
function timeout(_x) {
  return _timeout.apply(this, arguments);
}

function _timeout() {
  _timeout = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(time) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return new _Promise(function (resolve) {
              _setTimeout(resolve, time);
            });

          case 2:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _timeout.apply(this, arguments);
}

export { timeout };
